export default __webpack_public_path__ + "static/2flatsidedringtubes-ad14a8d44e22fb89f405367b280f8555.png";